import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AppStoreProvider } from './store/AppStore'
import './styles.css'


const FALLBACK_COVERS = [
  '/images/athletes/camille-cover.webp',
  '/images/athletes/lucas-cover.webp',
  '/images/athletes/ines-cover.webp',
  '/images/athletes/malik-cover.webp',
]
const FALLBACK_AVATARS = [
  '/images/athletes/camille-avatar.webp',
  '/images/athletes/lucas-avatar.webp',
  '/images/athletes/ines-avatar.webp',
  '/images/athletes/malik-avatar.webp',
]


const stableIndex = (value: string, modulo: number) => {
  let hash = 0
  for (let i = 0; i < value.length; i += 1) hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0
  return Math.abs(hash) % modulo
}

document.addEventListener('error', (event) => {
  const target = event.target
  if (!(target instanceof HTMLImageElement) || target.dataset.fallbackApplied === 'true') return

  target.dataset.fallbackApplied = 'true'
  const key = target.alt || target.src || 'athlink'
  const isAvatar = target.src.includes('pravatar') || target.width <= 160 || target.height <= 160
  const pool = isAvatar ? FALLBACK_AVATARS : FALLBACK_COVERS
  target.src = pool[stableIndex(key, pool.length)]
}, true)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AppStoreProvider>
        <App />
      </AppStoreProvider>
    </BrowserRouter>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => undefined))
}
